import React from "react";
import { motion } from "framer-motion";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const ContactPage = () => {
  const { t } = useTranslation(); 

  const items = [
    {
      icon: <FiMapPin className="text-secondary" size={32} />,
      title: t("contactPage.address"),
      lines: [
        t("contactPage.addressLine1"),
        t("contactPage.addressLine2"),
      ],
    },
    {
      icon: <FiPhone className="text-secondary" size={32} />,
      title: t("contactPage.phone"), 
      lines: [
        <a key="tel" href="tel:029215595528" className="hover:text-secondary">
          02921 559 55 28
        </a>,
      ],
    },
    {
      icon: <FiMail className="text-secondary" size={32} />,
      title: t("contactPage.email"), 
      lines: [
        <a
          key="mail"
          href="mailto:goldenarm59494@gmail.com"
          className="hover:text-secondary break-all"
        >
          goldenarm59494@gmail.com
        </a>,
      ],
    },
  ];

  return (
    <section className="pt-20 md:pt-24 pb-28 bg-accent">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Heading */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="font-display text-5xl md:text-6xl text-primary leading-tight">
            {t("contactPage.heading")} 
          </h1>
          <div className="w-24 h-1 bg-secondary mx-auto mt-4" />
          <p className="mt-5 text-primary/80 text-lg md:text-xl max-w-3xl mx-auto">
            {t("contactPage.subtext")} 
          </p>
        </motion.div>

        {/* Contact cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((it, idx) => (
            <motion.div
              key={idx}
              className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-8"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.07 * idx }}
            >
              <div className="flex items-center gap-4 mb-4">
                {it.icon}
                <h3 className="font-semibold text-2xl text-primary">{it.title}</h3>
              </div>
              <div className="text-primary/80 leading-relaxed text-lg space-y-1">
                {it.lines.map((line, i) => (
                  <div key={i}>{line}</div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
